var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShareGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(1, 2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-6h24v24H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3F3F3F",
    d: "M11.288 8.977H8.385C3.94 8.977 1.145 10.44 0 13.37c.203-2.822 1.24-5.032 3.112-6.628 2.48-2.117 5.141-2.508 8.237-2.571l.046-3.705 6.834 5.952-6.986 6.127.045-3.568z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShareGray);
export default __webpack_public_path__ + "static/media/icon-share-gray.1493849af82c5dbb6986ba8533ceb9e4.svg";
export { ForwardRef as ReactComponent };